import { makeStyles } from '@material-ui/core/styles';

const styles = theme => ({
  navigatorContainer: {
    maxWidth: 1024
  },
  navItem: {
    width: '20%',
    textAlign: 'center',
    marginTop: 40,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  },
  serviceName: {
    marginTop: 6,
    fontFamily: 'sofia-bold, sans-serif',
    fontSize: 20,
    lineHeight: '28px',
    textAlign: 'center',
    textTransform: 'capitalize'
  },
})

export default makeStyles(styles)
